import React, { ReactNode } from 'react';
import Icon from '../Controls/Icon/Icon';
import Image from '../Image/Image';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { AGGREGATOR_ORDER_SCHEME, AGGREGATORS, DOOK_TENANT_TYPES } from 'src/constants/aggregators';
import { ORDER_STATUS } from 'src/constants/order';
import { formatImagePath } from 'src/utils/formatter';
import { statusCouldBeChangedToNext } from '~/view/components/AggregatorManager/helpers/AggregatorManagerHelpers';
import { ORDER_DELIVERY_TYPES } from '~/constants/deliveryTypes';

interface IProps {
  aggregator: AGGREGATORS | null | undefined;
  sectionName: string;
  currentStatus?: ORDER_STATUS | undefined;
  nextStatus?: ORDER_STATUS | undefined;
  deliveryType?: ORDER_DELIVERY_TYPES | undefined;
  children?: ReactNode;
}

export default class AggregatorManager extends React.Component<IProps> {
  render() {
    if (!this.props.aggregator) {
      return this.props.children;
    }
    if (!AGGREGATOR_ORDER_SCHEME.hasOwnProperty(this.props.aggregator)) {
      return this.props.children;
    }
    const sections = AGGREGATOR_ORDER_SCHEME[this.props.aggregator];
    if (!sections.hasOwnProperty(this.props.sectionName)) {
      return this.props.children;
    }
    if (this.props.sectionName === 'statusManagment' && sections[this.props.sectionName]) {
      if (statusCouldBeChangedToNext(sections[this.props.sectionName], this.props.deliveryType, this.props.currentStatus, this.props.nextStatus)) {
        return this.props.children;
      }
    } else if (!sections[this.props.sectionName]) {
      return this.props.children;
    }
    return null;
  }
}

/**
 * Method return image for specific aggregator or cash icon when no aggregator key is matched
 *
 * @returns {React.ReactElement} image or icons component
 */
export const getPaymentMethodIcon = (aggregatorKey: AGGREGATORS, dookTenantType: DOOK_TENANT_TYPES | null | undefined): React.ReactElement => {
  switch (true) {
    case aggregatorKey === AGGREGATORS.JAHEEZ:
      return <Image src={formatImagePath(`jahez.svg`)} className="icons__jahez" />;
    case aggregatorKey === AGGREGATORS.CAREEM:
      return <Image src={formatImagePath(`careem.svg`)} className="icons__careem" />;
    case aggregatorKey === AGGREGATORS.DOOK && dookTenantType === DOOK_TENANT_TYPES.MINI_DOOK:
      return <Icon name={Icons.IcMiniDook} size={24} />;
    case aggregatorKey === AGGREGATORS.DOOK:
      return <Image src={formatImagePath(`dook.svg`)} className="icons__dook" />;
    case aggregatorKey === AGGREGATORS.HUNGER_STATION:
      return <Image src={formatImagePath(`ic_hunger_station.svg`)} className="icons__hunger_station" />;
    case aggregatorKey === AGGREGATORS.TO_YOU:
      return <Image src={formatImagePath(`ic_to_you.svg`)} className="icons__to_you" />;
    case aggregatorKey === AGGREGATORS.KEETA:
      return <Image src={formatImagePath(`ic_keeta.svg`)} className="icons__keeta" />;
    default:
      return <Icon name={Icons.Cash} />;
  }
};
